import { render, staticRenderFns } from "./StorageUnavail.vue?vue&type=template&id=6cac8b70&scoped=true&"
var script = {}
import style0 from "./StorageUnavail.vue?vue&type=style&index=0&id=6cac8b70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cac8b70",
  null
  
)

export default component.exports